import {redirectFromLogin} from "@/utils/loginRedirect";

export default {
    data() {
        return {
            checkPhoneKey: "sithMes.login.phone.check.switch",
            forceCheckPhoneKey: "sithMes.login.force.phone.check",
        }
    },
    methods: {
        redirectFromLogin,
        recordLoginInfoAndRedirect(data) {
            redirectFromLogin(data);
        },
        redirectToLogin() {
            localStorage.removeItem('em_sso_token')
            localStorage.removeItem('return_url')
            localStorage.removeItem('hideNoAuthMessage')
            window.location.href = process.env.VUE_APP_EM_SSO_LOGIN_URL
        }
    }
}
